<form [formGroup]="form">
  <div class="card mb-3 bg-2">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12 col-xl-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Nome</mat-label>
            <input placeholder="Nome" matInput type="text" formControlName="nome" maxlength="150" required>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-xl-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Descrição</mat-label>
            <input placeholder="Descrição" matInput type="text" formControlName="descricao" maxlength="150">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer clearfix">
      <div class="d-flex flex-row justify-content-end">
        <div class="pr-3">
          <button mat-raised-button color="primary"
                  title="Gravar"
                  label="Gravar"
                  [disabled]="form.invalid || (loading$ | async)"
                  (click)="gravar()">
                  <loading-icon [btnLabel]="'Gravar'" [loading]="loading$ | async"></loading-icon>
          </button>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</form>
